import { useState, ReactNode } from "react";
import { Helmet } from "react-helmet-async";

import { cn } from "@reactive-resume/utils";
import { useTheme } from "@reactive-resume/hooks";
import { CaretDown } from "@phosphor-icons/react";

interface CollapsibleSectionProps {
  header: ReactNode;
  content: ReactNode;
  defaultOpen?: boolean;
  id?: string;
  isVisible?: boolean;
}

// Renders collapsible section, commonly used
export const CollapsibleSection = ({
  header,
  content,
  defaultOpen = false,
  id,
  isVisible = true,
}: CollapsibleSectionProps) => {
  // const { isDarkMode } = useTheme();

  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <section id={id || "collapsibleSection"} className="grid gap-y-6  p-2 px-3 bg-white  border-gray-200/80 border-2 rounded-2xl  hover:shadow transition-shadow duration-200">
      {id === "css" && (
        <Helmet>
          {/* {isDarkMode && <link rel="stylesheet" href="/styles/prism-dark.css" />}
          {!isDarkMode && <link rel="stylesheet" href="/styles/prism-light.css" />} */}
          <link rel="stylesheet" href="/styles/prism-light.css" />
        </Helmet>
      )}
      {/* Header of the section */}
      <header
        className="flex cursor-pointer items-center justify-between"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {header}

        <button className="text-muted-foreground hover:text-foreground">
          <CaretDown
            size={18}
            className={cn("transition-transform duration-200", isOpen ? "rotate-180" : "rotate-0")}
          />
        </button>
      </header>
      {/* Content of the section */}
      {isOpen && <div>{content}</div>}
    </section>
  );
};
